import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=54ddc444&scoped=true&"
import script from "./SelectList.vue?vue&type=script&lang=js&"
export * from "./SelectList.vue?vue&type=script&lang=js&"
import style0 from "./SelectList.vue?vue&type=style&index=0&id=54ddc444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddc444",
  null
  
)

export default component.exports